import { css } from '@emotion/core';
import { colors, fontWeight, lineHeight, fontSize } from '../theme';

export const text1 = css`
  font-weight: ${fontWeight.normal};
  color: ${colors.greyDark};
  font-size: ${fontSize.large};
  line-height: ${lineHeight.normal};
`;

export const text2 = css`
  font-size: ${fontSize.medium};
  font-weight: ${fontWeight.normal};
  color: ${colors.blueDark};
  line-height: ${lineHeight.big};
`;

export const text2Medium = css`
  font-size: ${fontSize.medium};
  font-weight: ${fontWeight.normal};
  color: ${colors.blueDark};
  line-height: ${lineHeight.big};
  font-family: 'Heebo-Medium';
`;

export const text3 = css`
  font-size: ${fontSize.medium};
  color: ${colors.greySecondary};
  line-height: ${lineHeight.medium};
  font-weight: ${fontWeight.normal};
`;

export const text4 = css`
  font-size: ${fontSize.small};
  color: ${colors.greyDark};
  line-height: ${lineHeight.huge};
`;

export const text5 = css`
  font-size: ${fontSize.small};
  color: ${colors.greySecondary};
`;

export const text6 = css`
  font-size: ${fontSize.small};
  color: ${colors.greyMid};
  line-height: ${lineHeight.filtersBar};
`;
